"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreEntryTransactionToJSON = exports.ScoreEntryTransactionFromJSONTyped = exports.ScoreEntryTransactionFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ScoreEntryTransactionFromJSON(json) {
    return ScoreEntryTransactionFromJSONTyped(json, false);
}
exports.ScoreEntryTransactionFromJSON = ScoreEntryTransactionFromJSON;
function ScoreEntryTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hole': json['hole'],
        'score': json['score'],
        'player': !runtime_1.exists(json, 'player') ? undefined : _1.PlayerFromJSON(json['player']),
    };
}
exports.ScoreEntryTransactionFromJSONTyped = ScoreEntryTransactionFromJSONTyped;
function ScoreEntryTransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hole': value.hole,
        'score': value.score,
        'player': _1.PlayerToJSON(value.player),
    };
}
exports.ScoreEntryTransactionToJSON = ScoreEntryTransactionToJSON;
